<template>
    <v-container>
        <!-- Button that opens the emoji picker in a popup -->
        <v-menu v-model="emojiMenu" :close-on-content-click="false" offset-y>
            <template v-slot:activator="{ props }">
                <v-btn v-bind="props" color="primary" variant="outlined" icon>
                    <v-icon>mdi-emoticon-happy-outline</v-icon>
                </v-btn>
            </template>

            <!-- Emoji Picker inside the popup -->
            <div class="emoji-picker-container">
                <EmojiPicker @emoji-click="onEmojiClick" />
            </div>
        </v-menu>
    </v-container>
</template>

<script setup>
// Import Emoji Picker from vue3-emoji-picker
import EmojiPicker from 'vue3-emoji-picker';
import 'vue3-emoji-picker/css'

// Reactive variable for v-menu state
import { ref } from 'vue';
const emojiMenu = ref(false);

// Handle the selected emoji
const onEmojiClick = (emoji) => {
    console.log('Selected Emoji:', emoji.emoji); // You can store or use the selected emoji as needed
};
</script>

<style scoped>
/* Optional styling for the emoji picker popup */
.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}
</style>